(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maram-home"] && !Shopify.designMode) return;
  try {
    
function setupMaramSliders(scope) {
  scope.querySelectorAll('.maram-slider').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = Array.from(root.querySelectorAll('.maram-slide'));
    const dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
    const pause = root.querySelector('[data-slider-pause]');
    let index = 0;
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    }
    function start() {
      clearInterval(timer);
      if (!paused && !document.hidden && !root.matches(':hover') && !root.contains(document.activeElement)) timer = setInterval(() => {
        if (!root.isConnected) { clearInterval(timer); return; }
        show(index + 1);
      }, 5000);
    }
    function label() { pause.textContent = paused ? root.dataset.playLabel : root.dataset.pauseLabel; }
    root.querySelector('[data-slider-prev]').addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('[data-slider-next]').addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    pause.addEventListener('click', () => { paused = !paused; label(); start(); });
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', () => clearInterval(timer));
    root.addEventListener('focusout', () => setTimeout(start, 0));
    root.addEventListener('keydown', event => {
      if (event.target.matches('input,textarea,select')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); start(); }
    });
    document.addEventListener('visibilitychange', start);
    label(); start();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupMaramSliders(document));
else setupMaramSliders(document);
document.addEventListener('shopify:section:load', event => setupMaramSliders(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
